import * as JSPM from 'jsprintmanager';
import { initJSPM, jspmWSStatus } from './JSPMInit';
import { PrintService } from 'services/api/endpoints/print';
import EscPosEncoder from 'esc-pos-encoder';

export const getAvailablePrinters = async (): Promise<string[]> => {
  await initJSPM();
  if (jspmWSStatus()) {
    return (await JSPM.JSPrintManager.getPrinters()) as string[];
  } else {
    console.log('JSPM not available');
    return [];
  }
};

export const fillSpace = (leftItem = '-', rightItem = '-', length: number) => {
  const leftData = leftItem || '-';
  const rightData = rightItem || '-';
  // Calculate the total length of the concatenated string
  const totalLength = leftData.length + rightData.length;

  // Calculate the number of spaces needed to make the total length 30
  const spacesNeeded = length - totalLength;

  // Create a string of spaces
  const spaces = ' '.repeat(spacesNeeded);

  // Concatenate the variables with the spaces in between
  return leftData + spaces + rightData;
};

export const PRINT_TYPES = {
  fiveInchDotMatrix: { printFormat: 'd5', defaultItemsPerPage: 10 },
  sixInchDotMatrix: { printFormat: 'd6', defaultItemsPerPage: 10 },
  sevenInchDotMatrix: { printFormat: 'd7', defaultItemsPerPage: 12 },
  eightInchDotMatrix: { printFormat: 'd8', defaultItemsPerPage: 15 },
  laser: 'laser',
};

export const truncStr = (value: string, limit = 15) =>
  (value?.length || 0) > limit ? value?.substring(0, limit) : value;

export const fetchDMPPrintTemplate = async (billId: string) => {
  const res = await PrintService.getDotMatrixData(billId);
  const data = res.data.data;
  return data;
};

export const addStoreAddress = (encoder: EscPosEncoder, storeAddress: string, LENGTH: number) => {
  if (storeAddress.length <= LENGTH) {
    return encoder.line(storeAddress);
  } else {
    encoder = encoder.line(storeAddress.substr(0, LENGTH));
    return encoder.line(truncStr('   ' + storeAddress.substr(LENGTH), LENGTH));
  }
};
